module.exports = __webpack_public_path__ + "img/psmrj87qs14cs44wmgvdovbk2g95jnczhjffffbcfe3-1b9b-4b53-9e11-a024cb04c194.558e8a5a.png";